module.exports = {
    visibility: true,
    locked: false,
    defaultItems: {
        '17000800': 1
    },
    requireAttachments: [{
        'OR': ['/.*\.zip$/'],
        'message': 'Bitte laden Sie den erstellten Zip-Ordner aus Ihrer SKT-Box hoch!'
    }],
    // intro: require('./JawModelIntro.html'),
    title: 'Condy',
    disabled: true,
    image: '/img/Button-Condy-Plattform-Inactive.png',
    icon: 'times',
    iconPrefix: 'fas',
    iconColor: 'green',
    color: 'grey-light',
    requireShipping: false,
  tabs: [
    {
      id: 'masterdata',
      type: 'form',
      title: 'Stammdaten',
      form: require('./OrderForm.js')
    },
    {
      id: 'attachments',
      type: 'attachments',
      title: 'Attachments',
      intro: {
        de: 'Hier können Sie weitere Dateien hochladen (z.B. Photos, Planungsdaten, etc.)',
        en: 'Here you can upload additional files, e.g. photos, plans, etc.'
      },
      classes: {
        attachment: {
          fileLimit: 1,
          requires: 1,
          fileTypes: ['.zip'],
          fileNames: "^[0-9]{3,5}_[0-9]{6,8}.zip$",
          errorMessage: {
            en: 'The filename does not match the expected format (e.g. 12345_123456.zip). Have you uploaded the correct file?',
            de: 'Der Dateiname entspricht nicht dem korrekten Format. (z.B. 12345_123456.zip). Haben Sie die richtige Datei hochgeladen?'
          }
        }
      }
    },
    {
      id: 'addons',
      type: 'addons',
      title: 'Addons',
      hidePrices: false,
      category: 'chew',
    },
    {
      id: 'cart',
      type: 'cart',
      title: 'Cart',
      hideOrdered: true,
      hidePrices: false,
      requireShipping: false,
    }
  ]
}
